
// ScrollableForm.js

import React from 'react';
import '../../styles/foundation/ScrollableForm.css';



const ScrollableForm = ({ children, snap = false, scrollRef }) => {
    // `snap` opts a page into the subtle scroll-snap behaviour. It's off by
    // default so pages like Home/Contact/NoPage are unaffected.
    const childClassName = `scrollable-form-child${snap ? ' scrollable-form-child--snap' : ''}`;

    return (
        <div className='scrollable-form-parent'>
            <div className={childClassName} ref={scrollRef}>
                {children}
            </div>
        </div>
    );
};


export default ScrollableForm;